import theme from './shadow.scss';

export default {
    bind(el, binding) {
        const className = 'shadow-' + binding.value;
        el.className += ' ' + theme[className];
    },
    componentUpdated(el, binding) {
        const className = 'shadow-' + binding.value;

        setTimeout(() => {
            el.className += ' ' + theme[className];
        }, 1);
    },
};



// WEBPACK FOOTER //
// ./src/baseComponents/directives/Shadow/Shadow.js